function showModal(info){
  $('body').addClass('modal-show');
  $('.modal-container .modal-header .header').html(info.headerText);
  $('.modal-container .modal .description').html(info.descriptionText);
  var heroContent = info.heroContent || '';
  $('.modal-container .modal .hero').html(heroContent);
  var video = $('.modal-container video');
  if (video.length) {
    $.each(video, function () {
      var volumeEl = $(this)[0];
      var volume = parseFloat(volumeEl.getAttribute('volume'));
      $(this)[0].volume = volume;
    })
  }
}

function hideModal() {
  $('body').removeClass('modal-show');
  $('.modal-container .modal-header .header').html('');
  $('.modal-container .modal .description').html('');
  $('.modal-container .modal .hero').html('');
}

$('.closeModal').on('click', function(e) {
  e.preventDefault();
  hideModal();
});
